export default __webpack_public_path__ + "static/media/payment-waiting.d8383dcf.svg";